import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import {
  FiArrowRight,
  FiAward,
  FiBookOpen,
  FiCalendar,
  FiCamera,
  FiChevronDown,
  FiChevronLeft,
  FiChevronRight,
  FiCompass,
  FiCpu,
  FiExternalLink,
  FiGlobe,
  FiHome,
  FiMail,
  FiMapPin,
  FiMenu,
  FiMessageCircle,
  FiPhone,
  FiPlay,
  FiShield,
  FiUsers,
  FiUser,
  FiX,
} from "react-icons/fi";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa";

import schoolLogo from "../../image/logo/Logo.png";
import GetInTouch from "../GetInTouch/GetInTouch";
import heroStudent from "../../image/home_banner/admission-hero.png";
import eventsImage from "../../image/events/events_tile.webp";
import leadershipImage from "../../image/Principal_image.jpg";
import admissionsImage from "../../image/photo-gallery/Home page gallery 1.webp";
import campusLifeImage from "../../image/newImg/sports homepage.jpeg";
import achievementsImage from "../../image/award/proudmomet.webp";
import academicsImage from "../../image/photo-gallery/Home Page Gallery 4.webp";
import boardingImage from "../../image/boardingadmission/boarding_admission.jpg";
import alumniImage from "../../image/photo-galleryold/AllStudent.jpg";
import campusImage from "../../image/home_banner/school-image.webp";
import campusImage2 from "../../image/home_banner/Home Page Gallery 6.webp";
import campusVideo from "../../video/Visit.mp4";
import boardingHouseImage from "../../image/home_banner/Homebanner.jpg";
import alumniBannerImage from "../../image/Website_Banner.png";
import galleryImageOne from "../../image/photo-gallery/Home page gallery 1.webp";
import galleryImageTwo from "../../image/photo-gallery/Home page galley 2.webp";
import galleryImageThree from "../../image/photo-gallery/Home page gallery 3.webp";
import galleryImageFour from "../../image/photo-gallery/Home Page Gallery 4.webp";
import galleryImageFive from "../../image/photo-gallery/Home Page Gallery 6.webp";
import galleryImageSix from "../../image/photo-gallery/Home Page Gallery 6(1).webp";
import parentVoiceImage from "../../image/parents/d.png";

import "./HomePage.css";

// Add the boarding video YouTube link here (watch, share or embed URL).
const boardingVideoUrl = "https://www.youtube.com/watch?v=ijEbS6rNMH4";

function getYouTubeEmbedUrl(videoUrl) {
  if (!videoUrl.trim()) return "";

  try {
    const url = new URL(videoUrl);
    const hostname = url.hostname.replace(/^www\./, "");
    const videoId = hostname === "youtu.be"
      ? url.pathname.split("/")[1]
      : ["youtube.com", "m.youtube.com", "youtube-nocookie.com"].includes(hostname)
        ? url.searchParams.get("v") || url.pathname.match(/^\/(?:embed|shorts|live)\/([^/]+)/)?.[1]
        : "";

    return /^[\w-]{11}$/.test(videoId || "")
      ? `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=0&playsinline=1&rel=0`
      : "";
  } catch {
    return "";
  }
}

const mainNavItems = [
  { label: "Home", to: "/" },
  { label: "Mandatory Disclosure", to: "/mandatory-disclosures" },
  { label: "Blogs", to: "/blogs" },
];

const knowMoreGroups = [
  {
    label: "About Us",
    description: "Our purpose, people and community",
    icon: FiUsers,
    links: [
      { label: "Vision & Mission", to: "/vision-and-mission" },
      { label: "Message from Leadership", to: "/message" },
      { label: "Faculty & Staff", to: "/faculty-staff" },
      { label: "Parents' & Students' Voice", to: "/parents" },
    ],
  },
  {
    label: "Academics & Curriculum",
    description: "Future-ready learning at every stage",
    icon: FiBookOpen,
    links: [
      { label: "NEP 2020 Ready School", to: "/nep" },
      { label: "Curriculum", to: "/curriculum" },
      { label: "Pedagogical Approach", to: "/pedagogi" },
      { label: "Life Skill Curriculum", to: "/life-skill" },
      { label: "Assessment", to: "/examination" },
      { label: "Skill & Vocational Subjects", to: "/skill-vocational" },
      { label: "Results", to: "/results" },
      { label: "Booklist", to: "/books" },
    ],
  },
  {
    label: "Beyond Curriculum",
    description: "Leadership, exploration and expression",
    icon: FiAward,
    links: [
      { label: "Houses & Clubs", to: "/house-clubs" },
      { label: "Student Council", to: "/student-council" },
      { label: "Trips, Excursions & Field Visits", to: "/trips" },
      { label: "NCC, Band, Scouts & Guides", to: "/ncc-scouts" },
    ],
  },
];

const knowMoreQuickLinks = [
  { label: "Sports & Fitness", to: "/sports" },
  { label: "Infrastructure & Facilities", to: "/infrastructure" },
  { label: "Achievements & Laurels", to: "/awards" },
  { label: "Events & Happenings", to: "/events" },
  { label: "News & Media Coverage", to: "/news" },
  { label: "Illustrious Alumni", to: "/inspired" },
  { label: "Admissions", to: "/admission" },
];

const loginItems = [
  {
    label: "Parent Login",
    description: "Access updates and school information",
    to: "/parent-login",
    icon: FiUsers,
  },
  {
    label: "Student Login",
    description: "Learning resources and student services",
    to: "/student-login",
    icon: FiUser,
  },
  {
    label: "Fees Payment",
    description: "Secure online fee payment",
    to: "/Fees-Payment",
    icon: FiShield,
  },
];

const featureSlides = [
  {
    title: "Events & Happenings",
    action: "View all",
    to: "/events",
    image: eventsImage,
    alt: "HGS students being recognised at a school event",
    icon: FiCalendar,
  },
  {
    title: "Message from Leadership",
    action: "Read message",
    to: "/message",
    image: leadershipImage,
    alt: "Principal of HGS Bhimtal",
    icon: FiMessageCircle,
  },
  {
    title: "Admissions Open for 2027–2028",
    subtitle: "Nursery–Grade 9 & 11",
    action: "Apply now",
    to: "/admission",
    image: admissionsImage,
    alt: "Primary students and teachers at HGS Bhimtal",
    icon: FiBookOpen,
  },
  {
    title: "Campus Life",
    action: "Explore",
    to: "/infrastructure",
    image: campusLifeImage,
    alt: "Students playing football on the school field",
    icon: FiUsers,
  },
  {
    title: "Achievements",
    action: "View all",
    to: "/awards",
    image: achievementsImage,
    alt: "HGS Bhimtal board examination achievers",
    icon: FiAward,
  },
  {
    title: "Learning at HGS",
    action: "Discover",
    to: "/curriculum",
    image: academicsImage,
    alt: "HGS students reading in the school library",
    icon: FiBookOpen,
  },
  {
    title: "Day-cum-Boarding",
    action: "Know more",
    to: "/boarding",
    image: boardingImage,
    alt: "Boarding facilities at HGS Bhimtal",
    icon: FiUsers,
  },
  {
    title: "Our Alumni",
    action: "Get inspired",
    to: "/inspired",
    image: alumniImage,
    alt: "HGS students, alumni and faculty together",
    icon: FiAward,
  },
];

// Repeating the first cards keeps the carousel moving seamlessly at wide
// breakpoints where five cards are visible at once.
const loopingFeatureSlides = [
  ...featureSlides,
  ...featureSlides.slice(0, 4),
];

const journey = [
  { year: "1984", label: "The Foundation" },
  { year: "1995", label: "Growing Together" },
  { year: "2017", label: "Expanding Horizons" },
  { year: "2025", label: "National Recognition" },
  { year: "2026", label: "Future Ready" },
];

const testimonials = [
  {
    quote:
      "HGS Bhimtal is more than a school — it is a caring community that shapes character, inspires excellence and prepares children for a meaningful future.",
    source: "Parent of a Grade 8 student",
  },
  {
    quote:
      "The teachers encourage every child to ask questions, discover their strengths and grow with confidence both inside and beyond the classroom.",
    source: "Parent of a Grade 6 student",
  },
  {
    quote:
      "The school gave me opportunities to lead, create and compete. The values I learned here continue to guide every step of my journey.",
    source: "HGS Bhimtal alumnus",
  },
  {
    quote:
      "A beautiful campus, committed educators and a culture of care make learning at HGS a genuinely joyful experience for our children.",
    source: "Parent community",
  },
];

const galleryImages = [
  {
    src: galleryImageOne,
    alt: "Young learners and teachers at HGS Bhimtal",
  },
  {
    src: galleryImageTwo,
    alt: "Students participating in school activities",
  },
  {
    src: galleryImageThree,
    alt: "A memorable day on the HGS Bhimtal campus",
  },
  {
    src: galleryImageFour,
    alt: "Students learning together at HGS Bhimtal",
  },
  {
    src: galleryImageFive,
    alt: "The vibrant HGS Bhimtal school community",
  },
  {
    src: galleryImageSix,
    alt: "Student life at HGS Bhimtal",
  },
];

const schoolStrengths = [
  {
    label: "Holistic Education",
    to: "/curriculum",
    icon: FiBookOpen,
  },
  {
    label: "Experiential Learning",
    to: "/pedagogi",
    icon: FiCompass,
  },
  {
    label: "AI & Robotics Lab",
    to: "/skill-vocational",
    icon: FiCpu,
  },
  {
    label: "World-Class Infrastructure",
    to: "/infrastructure",
    icon: FiHome,
  },
  {
    label: "Global Exposure",
    to: "/trips",
    icon: FiGlobe,
  },
  {
    label: "Safe & Caring Environment",
    to: "/boarding",
    icon: FiShield,
  },
];

function HomePage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [openNavMenu, setOpenNavMenu] = useState(null);
  const [videoOpen, setVideoOpen] = useState(false);
  const boardingVideoEmbedUrl = getYouTubeEmbedUrl(boardingVideoUrl);
  const [featureIndex, setFeatureIndex] = useState(0);
  const [testimonialIndex, setTestimonialIndex] = useState(0);
  const featureTrackRef = useRef(null);
  const headerRef = useRef(null);
  const knowMoreCloseTimerRef = useRef(null);

  const cancelKnowMoreClose = () => {
    if (knowMoreCloseTimerRef.current) {
      window.clearTimeout(knowMoreCloseTimerRef.current);
      knowMoreCloseTimerRef.current = null;
    }
  };

  const openKnowMoreMenu = () => {
    cancelKnowMoreClose();
    setOpenNavMenu("know-more");
  };

  const closeKnowMoreMenuWithGrace = () => {
    cancelKnowMoreClose();
    knowMoreCloseTimerRef.current = window.setTimeout(() => {
      setOpenNavMenu((currentMenu) =>
        currentMenu === "know-more" ? null : currentMenu
      );
      knowMoreCloseTimerRef.current = null;
    }, 450);
  };

  const scrollToFeature = (nextIndex, behavior = "smooth") => {
    const track = featureTrackRef.current;
    if (!track) return;

    const normalizedIndex =
      (nextIndex + featureSlides.length) % featureSlides.length;
    const firstCard = track.querySelector(".hnew-feature-card");
    const gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
    const distance = firstCard
      ? normalizedIndex * (firstCard.getBoundingClientRect().width + gap)
      : 0;

    setFeatureIndex(normalizedIndex);
    track.scrollTo({ left: distance, behavior });
  };

  useEffect(() => {
    const sliderTimer = window.setInterval(() => {
      setFeatureIndex((currentIndex) => {
        const nextIndex = (currentIndex + 1) % featureSlides.length;
        const track = featureTrackRef.current;
        const firstCard = track?.querySelector(".hnew-feature-card");

        if (track && firstCard) {
          const gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
          track.scrollTo({
            left: nextIndex * (firstCard.getBoundingClientRect().width + gap),
            behavior: "smooth",
          });
        }

        return nextIndex;
      });
    }, 5200);

    return () => window.clearInterval(sliderTimer);
  }, []);

  useEffect(() => {
    const testimonialTimer = window.setInterval(() => {
      setTestimonialIndex(
        (currentIndex) => (currentIndex + 1) % testimonials.length
      );
    }, 5000);

    return () => window.clearInterval(testimonialTimer);
  }, []);

  useEffect(() => {
    if (!videoOpen) return undefined;

    const closeOnEscape = (event) => {
      if (event.key === "Escape") setVideoOpen(false);
    };

    document.addEventListener("keydown", closeOnEscape);
    return () => document.removeEventListener("keydown", closeOnEscape);
  }, [videoOpen]);

  useEffect(() => {
    const closeNavigation = (event) => {
      if (event.key === "Escape") {
        setMobileMenuOpen(false);
        setOpenNavMenu(null);
      }
    };

    const closeOnOutsideClick = (event) => {
      if (headerRef.current && !headerRef.current.contains(event.target)) {
        setOpenNavMenu(null);
      }
    };

    document.addEventListener("keydown", closeNavigation);
    document.addEventListener("mousedown", closeOnOutsideClick);
    return () => {
      document.removeEventListener("keydown", closeNavigation);
      document.removeEventListener("mousedown", closeOnOutsideClick);
    };
  }, []);

  useEffect(
    () => () => {
      if (knowMoreCloseTimerRef.current) {
        window.clearTimeout(knowMoreCloseTimerRef.current);
      }
    },
    []
  );

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
    setOpenNavMenu(null);
  };

  const toggleNavMenu = (menuName) => {
    setOpenNavMenu((currentMenu) =>
      currentMenu === menuName ? null : menuName
    );
  };

  return (
    <div className="hnew-page">
      <header className="hnew-header" ref={headerRef}>
        <div className="hnew-header-inner">
          <Link
            className="hnew-brand"
            to=""
            aria-label="HGS Bhimtal home"
          >
            <img src={schoolLogo} alt="HGS Bhimtal crest" />
            <span>
              <strong>HGS Bhimtal</strong>              
            </span>
          </Link>

          <nav
            className={`hnew-nav ${mobileMenuOpen ? "hnew-nav-open" : ""}`}
            aria-label="Main navigation"
          >
            {mainNavItems.map((item, index) => (
              <Link
                key={item.label}
                className={index === 0 ? "hnew-nav-active" : ""}
                to={item.to}
                onClick={closeMobileMenu}
              >
                {item.label}
              </Link>
            ))}

            <div
              className={`hnew-nav-dropdown hnew-nav-dropdown-mega ${
                openNavMenu === "know-more" ? "hnew-dropdown-open" : ""
              }`}
              onMouseEnter={openKnowMoreMenu}
              onMouseLeave={closeKnowMoreMenuWithGrace}
            >
              <button
                className="hnew-nav-trigger"
                type="button"
                aria-expanded={openNavMenu === "know-more"}
                aria-controls="hnew-know-more-menu"
                onClick={() => {
                  cancelKnowMoreClose();
                  toggleNavMenu("know-more");
                }}
              >
                Know More <FiChevronDown aria-hidden="true" />
              </button>

              <div
                className="hnew-dropdown-panel hnew-mega-menu"
                id="hnew-know-more-menu"
                onMouseEnter={openKnowMoreMenu}
              >
                <div className="hnew-mega-intro">
                  <span>Discover HGS</span>
                  <h2>Everything that makes school life exceptional.</h2>
                  <p>
                    Explore our learning approach, vibrant student life,
                    facilities and achievements.
                  </p>
                  <Link to="/book-tour" onClick={closeMobileMenu}>
                    Plan a school visit <FiArrowRight aria-hidden="true" />
                  </Link>
                </div>

                <div className="hnew-mega-content">
                  <div className="hnew-mega-groups">
                    {knowMoreGroups.map((group) => {
                      const GroupIcon = group.icon;
                      return (
                        <details
                          className="hnew-mega-group"
                          key={group.label}
                          open
                        >
                          <summary className="hnew-mega-group-heading">
                            <span>
                              <GroupIcon aria-hidden="true" />
                            </span>
                            <div>
                              <h3>{group.label}</h3>
                              <p>{group.description}</p>
                            </div>
                            <FiChevronDown
                              className="hnew-mega-group-chevron"
                              aria-hidden="true"
                            />
                          </summary>
                          <div className="hnew-mega-links">
                            {group.links.map((item) => (
                              <Link
                                key={item.label}
                                to={item.to}
                                onClick={closeMobileMenu}
                              >
                                {item.label}
                                <FiArrowRight aria-hidden="true" />
                              </Link>
                            ))}
                          </div>
                        </details>
                      );
                    })}
                  </div>

                  <div className="hnew-mega-quick-links">
                    <p>More at HGS</p>
                    {knowMoreQuickLinks.map((item) => (
                      <Link
                        key={item.label}
                        to={item.to}
                        onClick={closeMobileMenu}
                      >
                        {item.label} <FiArrowRight aria-hidden="true" />
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <Link to="/contact-us" onClick={closeMobileMenu}>
              Contact Us
            </Link>

            <div
              className={`hnew-nav-dropdown hnew-login-dropdown ${
                openNavMenu === "login" ? "hnew-dropdown-open" : ""
              }`}
              onMouseEnter={() => setOpenNavMenu("login")}
              onMouseLeave={() => setOpenNavMenu(null)}
            >
              <button
                className="hnew-nav-trigger"
                type="button"
                aria-expanded={openNavMenu === "login"}
                aria-controls="hnew-login-menu"
                onClick={() => toggleNavMenu("login")}
              >
                Login <FiChevronDown aria-hidden="true" />
              </button>
              <div
                className="hnew-dropdown-panel hnew-login-menu"
                id="hnew-login-menu"
              >
                <div className="hnew-login-heading">
                  <span>HGS Portal</span>
                  <strong>Welcome back</strong>
                </div>
                {loginItems.map((item) => {
                  const LoginIcon = item.icon;
                  return (
                    <Link
                      className="hnew-login-link"
                      key={item.label}
                      to={item.to}
                      onClick={closeMobileMenu}
                    >
                      <span className="hnew-login-icon">
                        <LoginIcon aria-hidden="true" />
                      </span>
                      <span>
                        <strong>{item.label}</strong>
                        <small>{item.description}</small>
                      </span>
                      <FiArrowRight className="hnew-login-arrow" aria-hidden="true" />
                    </Link>
                  );
                })}
              </div>
            </div>

            <Link to="/book-tour" onClick={closeMobileMenu}>
              Book a Tour
            </Link>
            <Link
              className="hnew-apply hnew-apply-mobile"
              to="/admission"
              onClick={closeMobileMenu}
            >
              Admission
            </Link>
          </nav>

          <Link className="hnew-apply hnew-apply-desktop" to="/admission">
            Admission
          </Link>

          <button
            className="hnew-menu-toggle"
            type="button"
            aria-label={mobileMenuOpen ? "Close navigation" : "Open navigation"}
            aria-expanded={mobileMenuOpen}
            onClick={() => {
              setMobileMenuOpen((isOpen) => !isOpen);
              setOpenNavMenu(null);
            }}
          >
            {mobileMenuOpen ? <FiX /> : <FiMenu />}
          </button>
        </div>
      </header>

      <main>
        <section className="hnew-hero" aria-labelledby="hnew-hero-title">
          <div
            className="hnew-hero-image"
            style={{ backgroundImage: `url(${heroStudent})` }}
            aria-hidden="true"
          />
          <div className="hnew-hero-wash" aria-hidden="true" />
          <div className="hnew-container hnew-hero-inner">
            <div className="hnew-hero-copy">
              <p className="hnew-eyebrow">HGS, Bhimtal</p>
              <h1 id="hnew-hero-title">
                Every Child.
                <br />
                Every Opportunity.
                <br />
                Every Day.
              </h1>
              <span className="hnew-title-line" aria-hidden="true" />
              <p className="hnew-hero-description">
                Empowering children to become confident, compassionate and
                capable leaders of tomorrow.
              </p>              
            </div>
          </div>
        </section>

        <section className="hnew-feature-section" aria-label="Explore HGS">
          <div className="hnew-container hnew-feature-shell">
            <button
              className="hnew-slider-control hnew-slider-prev"
              type="button"
              aria-label="Previous feature"
              onClick={() => scrollToFeature(featureIndex - 1)}
            >
              <FiChevronLeft />
            </button>

            <div className="hnew-feature-track" ref={featureTrackRef}>
              {loopingFeatureSlides.map((slide, index) => {
                const Icon = slide.icon;
                return (
                  <article
                    className="hnew-feature-card"
                    key={`${slide.title}-${index}`}
                  >
                    <div className="hnew-feature-heading">
                      <Icon className="hnew-feature-icon" aria-hidden="true" />
                      <div>
                        <h2>
                          {slide.title}
                          {slide.subtitle && <span className="hnew-feature-subtitle">{slide.subtitle}</span>}
                        </h2>
                        <Link to={slide.to}>
                          {slide.action} <FiArrowRight aria-hidden="true" />
                        </Link>
                      </div>
                    </div>
                    <Link
                      className="hnew-feature-image-link"
                      to={slide.to}
                      aria-label={`${slide.action}: ${slide.title}`}
                    >
                      <img src={slide.image} alt={slide.alt} />
                    </Link>
                  </article>
                );
              })}
            </div>

            <button
              className="hnew-slider-control hnew-slider-next"
              type="button"
              aria-label="Next feature"
              onClick={() => scrollToFeature(featureIndex + 1)}
            >
              <FiChevronRight />
            </button>
          </div>

          <div className="hnew-feature-dots" aria-label="Feature slides">
            {featureSlides.map((slide, index) => (
              <button
                key={slide.title}
                className={index === featureIndex ? "hnew-dot-active" : ""}
                type="button"
                aria-label={`Show ${slide.title}`}
                aria-current={index === featureIndex ? "true" : undefined}
                onClick={() => scrollToFeature(index)}
              />
            ))}
          </div>
        </section>

        <section className="hnew-journey" aria-labelledby="hnew-journey-title">
          <div className="hnew-container">
            <p className="hnew-section-kicker">A legacy of learning</p>
            <h2 id="hnew-journey-title">Our Journey</h2>
            <div className="hnew-timeline">
              {journey.map((milestone) => (
                <div className="hnew-milestone" key={milestone.year}>
                  <strong>{milestone.year}</strong>
                  <span className="hnew-timeline-dot" aria-hidden="true" />
                  <small>{milestone.label}</small>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="hnew-story" aria-label="Experience and testimonials">
          <button
            className="hnew-campus-story"
            type="button"
            onClick={() => setVideoOpen("boarding")}
            aria-label="Play the HGS Bhimtal campus video"
          >
            <img src={campusImage} alt="HGS campus" />
            <span className="hnew-campus-overlay" />
            <span className="hnew-story-play">
              <FiPlay aria-hidden="true" />
            </span>
            <span className="hnew-story-label">Experience HGS Bhimtal</span>
          </button>

          <div className="hnew-testimonials" aria-live="polite">
            <span className="hnew-quote-mark" aria-hidden="true">
              “
            </span>
            <blockquote key={testimonialIndex}>
              <p>{testimonials[testimonialIndex].quote}</p>
              <footer>— {testimonials[testimonialIndex].source}</footer>
            </blockquote>
            <div className="hnew-testimonial-dots" aria-label="Testimonials">
              {testimonials.map((testimonial, index) => (
                <button
                  key={testimonial.source}
                  className={
                    index === testimonialIndex ? "hnew-testimonial-active" : ""
                  }
                  type="button"
                  aria-label={`Show testimonial ${index + 1}`}
                  aria-current={index === testimonialIndex ? "true" : undefined}
                  onClick={() => setTestimonialIndex(index)}
                />
              ))}
            </div>            
          </div>
        </section>

        <section
          className="hnew-boarding-showcase"
          aria-labelledby="hnew-boarding-title"
        >
          <img
            src={boardingHouseImage}
            alt="Boarding students learning together at HGS Bhimtal"
          />
          <div className="hnew-boarding-shade" aria-hidden="true" />
          <div className="hnew-container hnew-boarding-content">
            <p className="hnew-section-kicker hnew-section-kicker-light">
              A home beyond home
            </p>
            <h2 id="hnew-boarding-title">Life In Boarding House</h2>
            <p>
              A caring, structured environment where friendships grow,
              independence flourishes and every child feels at home.
            </p>
            <div className="hnew-boarding-actions">
              <Link className="hnew-outline-button" to="/boarding">
                Know More <FiArrowRight aria-hidden="true" />
              </Link>
              <button
                className="hnew-outline-button"
                type="button"
                aria-haspopup="dialog"
                onClick={() => setVideoOpen("boarding")}
              >
                Watch Video <FiPlay aria-hidden="true" />
              </button>
            </div>
          </div>
        </section>

        <section
          className="hnew-alumni-showcase"
          aria-labelledby="hnew-alumni-title"
        >
          <img src={alumniBannerImage} alt="" aria-hidden="true" />
          <div className="hnew-container hnew-alumni-content">
            <p className="hnew-section-kicker">A legacy that lives on</p>
            <h2 id="hnew-alumni-title">Illustrious Alumni</h2>
            <p>
              Get inspired by the success stories of our notable alumni and
              discover where an HGS education can lead.
            </p>
            <Link className="hnew-primary-button" to="/inspired">
              Read Their Stories <FiArrowRight aria-hidden="true" />
            </Link>
          </div>
        </section>

        <section className="hnew-contact" aria-labelledby="hnew-contact-title">
          <div className="hnew-container hnew-contact-shell">
            <div className="hnew-contact-intro">
              <span className="hnew-contact-number">01</span>
              <p className="hnew-section-kicker hnew-section-kicker-light">
                Begin a conversation
              </p>
              <h2 id="hnew-contact-title">Let&apos;s shape their future together.</h2>
              <p>
                Share a few details and our admissions team will help with
                everything you need to know about HGS Bhimtal.
              </p>
              <div className="hnew-contact-details">
                <a href="tel:+918126482292">
                  <FiPhone aria-hidden="true" />
                  <span>
                    <small>Call admissions</small>
                    +91 81264 82292
                  </span>
                </a>
                <a href="mailto:principal.bhimtal@hgedu.org">
                  <FiMail aria-hidden="true" />
                  <span>
                    <small>Email us</small>
                    principal.bhimtal@hgedu.org
                  </span>
                </a>
              </div>
            </div>
            <div className="hnew-contact-form">
              <GetInTouch />
            </div>
          </div>
        </section>

        <section className="hnew-gallery" aria-labelledby="hnew-gallery-title">
          <div className="hnew-container">
            <div className="hnew-gallery-heading">
              <div>
                <p className="hnew-section-kicker">Moments from our campus</p>
                <h2 id="hnew-gallery-title">Photo Gallery</h2>
              </div>
              <span className="hnew-gallery-mark" aria-hidden="true">
                <FiCamera />
              </span>
            </div>

            <div className="hnew-gallery-grid">
              {galleryImages.map((image, index) => (
                <figure
                  className={`hnew-gallery-item hnew-gallery-item-${index + 1}`}
                  key={image.src}
                >
                  <img src={image.src} alt={image.alt} loading="lazy" />
                  <span className="hnew-gallery-overlay" aria-hidden="true" />
                </figure>
              ))}
            </div>
          </div>
        </section>

        <section
          className="hnew-highlights"
          aria-label="What makes HGS Bhimtal special"
        >
          <div className="hnew-container">
            <div className="hnew-strengths">
              {schoolStrengths.map((strength) => {
                const Icon = strength.icon;

                return (
                  <Link
                    className="hnew-strength"
                    to={strength.to}
                    key={strength.label}
                  >
                    <span className="hnew-strength-icon" aria-hidden="true">
                      <Icon />
                    </span>
                    <strong>{strength.label}</strong>
                  </Link>
                );
              })}
            </div>

            <div className="hnew-highlight-cards">
              <article className="hnew-parent-highlight">
                <img
                  src={parentVoiceImage}
                  alt="Anuradha, an HGS Bhimtal parent"
                  loading="lazy"
                />
                <blockquote>
                  <span aria-hidden="true">&ldquo;</span>
                  <p>
                    The school offers a caring environment, strong academics,
                    sports, laboratories and robotics that help children grow
                    with confidence.
                  </p>
                  <footer>&mdash; Anuradha, HGS parent</footer>
                </blockquote>
              </article>

              <button
                className="hnew-video-highlight"
                type="button"
                onClick={() => setVideoOpen("boarding")}
                aria-label="Play the Experience HGS Bhimtal campus video"
              >
                <img
                  src={campusImage2}
                  alt="HGS Bhimtal campus"
                  loading="lazy"
                />
                <span className="hnew-video-highlight-shade" aria-hidden="true" />
                <span className="hnew-video-highlight-title">
                  Experience HGS Bhimtal
                </span>
                <span className="hnew-video-highlight-action">
                  Play Video <FiPlay aria-hidden="true" />
                </span>
              </button>

              <article className="hnew-admissions-highlight">
                <div>
                  <h2>Admissions Open for 2027–2028</h2>
                  <p>Nursery–Grade 9 &amp; 11</p>
                  <p>Limited seats available. Enrol your child today.</p>
                  <Link to="/admission">
                    Apply Now <FiArrowRight aria-hidden="true" />
                  </Link>
                </div>
                <img
                  src={admissionsImage}
                  alt="HGS Bhimtal students and teachers"
                  loading="lazy"
                />
              </article>
            </div>
          </div>
        </section>
      </main>

      <footer className="hnew-footer">
        <div className="hnew-footer-accent" aria-hidden="true" />
        <div className="hnew-container hnew-footer-grid">
          <div className="hnew-footer-brand">
            <Link to="/" aria-label="Go to the current HGS Bhimtal homepage">
              <img src={schoolLogo} alt="HGS Bhimtal crest" />
            </Link>
            <div>
              <h2>HGS</h2>
              <p>
                A day-cum-boarding school nurturing knowledge, character and
                compassion in the hills of Bhimtal.
              </p>
            </div>
          </div>

          <div className="hnew-footer-links">
            <h3>Quick Links</h3>
            <a
              href="https://hermanngmeinereducationalinstitutions.org/about-the-institution"
              target="_blank"
              rel="noreferrer"
            >
              About HG Educational Institutions
              <FiExternalLink aria-hidden="true" />
            </a>
            <Link to="/nep">Academics &amp; Curriculum</Link>
            <Link to="/contact-us">Contact Us</Link>
            <a
              href="https://www.soschildrensvillages.in/about-us/"
              target="_blank"
              rel="noreferrer"
            >
              SOS Children&apos;s Villages of India
              <FiExternalLink aria-hidden="true" />
            </a>
            <Link to="/house-clubs">Beyond Curriculum</Link>
            <Link to="/news">News &amp; Media Coverage</Link>
            <Link to="/infrastructure">Infrastructure &amp; Facilities</Link>
          </div>

          <div className="hnew-footer-contact">
            <h3>Contact</h3>
            <p>
              <FiMapPin aria-hidden="true" />
              HGS Bhimtal, Nainital, Uttarakhand 263136
            </p>
            <a href="tel:+918126482292">
              <FiPhone aria-hidden="true" /> +91 81264 82292
            </a>
            <a href="mailto:principal.bhimtal@hgedu.org">
              <FiMail aria-hidden="true" /> principal.bhimtal@hgedu.org
            </a>
          </div>
        </div>

        <div className="hnew-container hnew-footer-bottom">
          <p>© {new Date().getFullYear()} HGS Bhimtal</p>
          <div className="hnew-socials" aria-label="Social media links">
            <a
              href="https://www.facebook.com/HGSBHIMTAL1984"
              target="_blank"
              rel="noreferrer"
              aria-label="Facebook"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://www.instagram.com/hermanngmeinerschoolbhimtal/"
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.linkedin.com/in/hermann-gmeiner-school-bhimtal-536464337/"
              target="_blank"
              rel="noreferrer"
              aria-label="LinkedIn"
            >
              <FaLinkedinIn />
            </a>
            <a
              href="https://www.youtube.com/results?search_query=hermann+gmeiner+school+bhimtal"
              target="_blank"
              rel="noreferrer"
              aria-label="YouTube"
            >
              <FaYoutube />
            </a>
          </div>
        </div>
      </footer>

      {videoOpen && (
        <div
          className="hnew-video-modal"
          role="dialog"
          aria-modal="true"
          aria-label={videoOpen === "boarding" ? "Life in Boarding House video" : "HGS Bhimtal campus video"}
          onMouseDown={(event) => {
            if (event.currentTarget === event.target) setVideoOpen(false);
          }}
        >
          <div className="hnew-video-dialog">
            <button
              className="hnew-video-close"
              type="button"
              aria-label="Close video"
              onClick={() => setVideoOpen(false)}
            >
              <FiX />
            </button>
            {videoOpen === "boarding" ? (
              boardingVideoEmbedUrl ? (
                <iframe
                  src={boardingVideoEmbedUrl}
                  title="Life in Boarding House at HGS Bhimtal"
                  allow="autoplay; encrypted-media; picture-in-picture; fullscreen"
                  allowFullScreen
                />
              ) : (
                <div className="hnew-video-placeholder">
                  <FiPlay aria-hidden="true" />
                  <h2>Life In Boarding House</h2>
                  <p>Video coming soon.</p>
                </div>
              )
            ) : (
              <video src={campusVideo} controls autoPlay playsInline>
                Your browser does not support HTML video.
              </video>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default HomePage;
